import bmpegts from "mpegts.js";
bmpegts.LoggingControl.enableWarn = false;
export default bmpegts;
